import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appDragScroll]',
    standalone: true
})
export class DragScrollDirective {
    private isDragging = false;
    private startX = 0;
    private scrollLeft = 0;

    constructor(private el: ElementRef) {
        this.el.nativeElement.style.cursor = 'grab';
    }

    @HostListener('mousedown', ['$event'])
    onMouseDown(event: MouseEvent) {
        this.isDragging = true;
        this.startX = event.pageX - this.el.nativeElement.offsetLeft;
        this.scrollLeft = this.el.nativeElement.scrollLeft;
        this.el.nativeElement.style.cursor = 'grabbing';
        event.preventDefault();
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        this.isDragging = false;
        this.el.nativeElement.style.cursor = 'grab';
    }

    @HostListener('mouseup')
    onMouseUp() {
        this.isDragging = false;
        this.el.nativeElement.style.cursor = 'grab';
    }

    @HostListener('mousemove', ['$event'])
    onMouseMove(event: MouseEvent) {
        if (!this.isDragging) return;
        const x = event.pageX - this.el.nativeElement.offsetLeft;
        const walk = (x - this.startX) * 1; // scroll speed
        this.el.nativeElement.scrollLeft = this.scrollLeft - walk;
    }
}
